import React from "react";

function Schedule() {
  const amenities = [
    "Individual treatment sections for men & women",
    "Hydro - Acupressure walk track",
    "Well ventilated yoga hall",
    "Walking Track & Shuttle court (Outdoor)",
    "Natural Water falls",
    "Well equipped gymnasium",
    "Library room for peaceful study",
    "Stall for books & basic wellness needs",
    "Childrens Park with play equipments",
    "Indoor games like Carrom & Chess",
    "High-speed Internet access",
    "Eco Tourism surrounding setups",
  ];

  const dietItems = [
    { time: "6.30 to 9.30 am", name: "Herbal Tea (Both Sweet & Sweet less)" },
    { time: "8.00 to 10.00 am", name: "Herbal Juice" },
    { time: "9.00 to 10.30 am", name: "Barley" },
    { time: "9.30 to 10.30 am", name: "Ginger Garlic Juice" },
    { time: "11.00 to 1.00 pm", name: "Gen diet (Aval, Salad, Chutney & Fruit)" },
    { time: "11.00 to 12.30 pm", name: "Fasting Juice & Fruits" },
    { time: "12.00 to 12.30 pm", name: "Special Juice (only prescribed by doctor)" },
    { time: "1.00 to 2.30 pm", name: "Carrot / Beetroot / Ashgourd / Vilvam / Tulasi Juice / Soup" },
    { time: "2.15 to 3.30 pm", name: "Ragi Malt & Lemon Juice" },
    { time: "2.15 to 2.30 pm", name: "Tender Coconut" },
    { time: "4.00 to 4.30 pm", name: "Special Juice (only prescribed by doctor)" },
    { time: "4.00 to 5.30 pm", name: "Fruit Juice / Barley / Fenugreek & Sprouts" },
    { time: "5.30 to 6.45 pm", name: "Herbal tea & Amla Juice" },
    { time: "7.00 to 8.00 pm", name: "Fruit Diet (Seasonal fruits, Dates, Coconut & Puffed Rice) & Hot Water" },
  ];

  const yogaSessions = [
    { icon: "🌅", period: "Morning:", time: "6.15 to 6.30 am", activity: "Meditation (Self)" },
    { icon: "🧘‍♂️", period: "Morning:", time: "6.30 to 8.00 am", activity: "Yoga Class (General)" },
    { icon: "🌇", period: "Evening:", time: "4.30 to 5.30 pm", activity: "Yoga Class (General)" },
    { icon: "🧘‍♀️", period: "Evening:", time: "4.00 to 5.00 pm", activity: "Special Yoga" },
  ];

  const timingCards = [
    {
      title: "Mud Pack Timings",
      content: [
        { label: "☀️ Morning :", value: "8.00 to 8.45 am (Out Side)" },
        { label: "🏢 Morning :", value: "8.15 to 8.45 am (Room)" },
        { label: "🌤️ Afternoon :", value: "2.15 to 2.30 pm (Out Side)" },
      ],
    },
    {
      title: "Kriyas",
      content: [{ label: "✨", value: "8.00 to 8.30 am" }],
    },
    {
      title: "Office Time",
      content: [{ label: "💼", value: "8.30 am to 8.30 pm" }],
    },
    {
      title: "Treatment",
      content: [
        { label: "🕢", value: "9.15 am to 1.00 pm" },
        { label: "🕑", value: "2.30 pm to 4.30 pm" },
      ],
    },
  ];

  const doctorSessions = [
    {
      title: "👨‍⚕️ Morning Session 1:",
      time: "9.30 am to 1.00 pm",
      tag: "Admission & IP",
    },
    {
      title: "👨‍⚕️ Morning Session 2:",
      time: "10.30 am to 2.00 pm",
      tag: "IP & OP",
    },
    {
      title: "🌙 Evening Session:",
      time: "6.30 pm to 8.30 pm",
      tag: null,
    },
  ];

  return (
    <section className="w-full bg-[#f5f5f0] py-12 px-4 sm:px-6 md:px-12 font-poppins min-h-screen text-neutral-900 flex justify-center items-center">
      <div className="w-full max-w-7xl grid grid-cols-1 lg:grid-cols-2 shadow-2xl overflow-hidden rounded-3xl bg-white border border-green-100">

        {/* LEFT COLUMN */}
        <div className="bg-[#fcfcf9] p-6 md:p-10 border-b lg:border-b-0 lg:border-r border-green-100 space-y-10">
          
          {/* Amenities Container */}
          <div>
            <h2 className="bg-green-700 text-white inline-block px-5 py-2 text-xl md:text-2xl font-black rounded-xl mb-6 shadow-md shadow-green-100">
              Amenities
            </h2>
            <ul className="space-y-3.5 text-base md:text-lg font-bold text-neutral-900 pl-1">
              {amenities.map((item, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <span className="text-green-700 font-black shrink-0">✔</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Diet Schedule Container */}
          <div>
            <h2 className="bg-green-700 text-white inline-block px-5 py-2 text-xl md:text-2xl font-black rounded-xl mb-6 shadow-md shadow-green-100">
              Diet Schedule
            </h2>
            <div className="space-y-4 text-base md:text-lg font-bold text-neutral-900 pl-1">
              {dietItems.map((item, idx) => (
                <div key={idx} className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-2">
                  <div className="text-red-600 flex items-center gap-2 shrink-0 min-w-[200px]">
                    <span>⏰</span>
                    <time>{item.time}</time>
                  </div>
                  <span className="hidden sm:inline text-neutral-400 font-medium">:</span>
                  <span>{item.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Yoga Time Container */}
          <div>
            <h2 className="bg-green-700 text-white inline-block px-5 py-2 text-xl md:text-2xl font-black rounded-xl mb-6 shadow-md shadow-green-100">
              Yoga Time
            </h2>
            <div className="space-y-4 text-base md:text-lg font-bold text-neutral-900 pl-1">
              {yogaSessions.map((session, idx) => (
                <div key={idx} className="flex items-start gap-2.5">
                  <span className="text-xl shrink-0">{session.icon}</span>
                  <p>
                    <span className="text-green-800 font-black mr-1.5">{session.period}</span> 
                    <span className="text-red-600 mr-2">{session.time}</span> {session.activity}
                  </p>
                </div>
              ))}
            </div>
          </div>

        </div>

        {/* RIGHT COLUMN */}
        <div className="bg-white p-6 md:p-10 space-y-6 flex flex-col justify-start ">
          
          {/* Dynamic Map for General Timing Cards */}
          {timingCards.map((card, idx) => (
            <div key={idx} className="bg-green-50/40 p-5 rounded-2xl border border-green-100/70 shadow-sm">
              <h3 className="bg-green-700 text-white font-black inline-block px-4 py-1.5 text-base rounded-lg shadow-sm mb-4">
                {card.title}
              </h3>
              <div className="space-y-2 text-base md:text-lg text-neutral-750 font-[700] pl-1">
                {card.content.map((row, rowIdx) => (
                  <p key={rowIdx} className="flex items-center gap-2">
                    <span>{row.label}</span> <span>{row.value}</span>
                  </p>
                ))}
              </div>
            </div>
          ))}

          {/* Doctor Consulting Time Card */}
          <div className="bg-green-50/40 p-5 rounded-2xl border border-green-100/70 shadow-sm">
            <h3 className="bg-green-700 text-white font-black inline-block px-4 py-1.5 text-base rounded-lg shadow-sm mb-4">
              Doctor Consulting Time
            </h3>
            <div className="text-base md:text-lg font-bold text-neutral-750 space-y-4 pl-1">
              {doctorSessions.map((session, idx) => (
                <div 
                  key={idx} 
                  className={`${idx !== doctorSessions.length - 1 ? "border-b border-green-100/80 pb-3" : ""}`}
                >
                  <p className="text-green-900 font-black flex items-center gap-1.5 mb-0.5">
                    {session.title}
                  </p>
                  <p className="pl-7">
                    {session.time}
                    {session.tag && (
                      <> (<span className="text-green-700 font-black">{session.tag}</span>)</>
                    )}
                  </p>
                </div>
              ))}
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}

export default Schedule;